import { render, staticRenderFns } from "./StudentDocumentList.vue?vue&type=template&id=4d49dadb&scoped=true&"
import script from "./StudentDocumentList.vue?vue&type=script&lang=js&"
export * from "./StudentDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocumentList.vue?vue&type=style&index=0&id=4d49dadb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49dadb",
  null
  
)

export default component.exports